import { useState } from "react";
import "./App.css";

export default function App() {
  const [lang, setLang] = useState("sv");

  const text = {
    sv: {
      date: "15 augusti 2026",
      location: "Hökhuvuds Kyrka, Östhammar",
      party: "Efterföljande fest på Hökhuvuds Bygdegård",
      rsvpText: "Låt oss veta om du kan komma senast den 1 juni.",
      rsvpButton: "OSA här",
      moreInfo: "Mer information om dagen",

      ceremonyTitle: "Vigsel",
      ceremonyText: "Sker i Hökhuvuds kyrka, Gimo, klockan 14.00.",

      celebrationTitle: "Firande – middag och fest",
      celebrationText:
        "Från kyrkan erbjuds gemensam transport till Hökhuvuds bygdegård där mingel, middag och fest väntar.",

      dressTitle: "Klädsel",
      dressText: "Sommarfin kostym.",

      childrenTitle: "Barn",
      childrenText:
        "Vi gillar barn men den här dagen firar vi i vuxnas sällskap.",

      speechTitle: "Tal och frågor",
      speechText:
        "Skriv till våra toastmasters om du vill hålla tal eller har några frågor: adamfredrikatoast@gmail.com",

      giftsTitle: "Presenter",
      giftsText:
        'Er närvaro är den bästa presenten! Vill ni ändå ge något blir vi glada för ett bidrag till vår bröllopsresa. Swisha till vår toastmaster Johanna Dyremark på 070 489 17 16 och märk "Bröllop".',

      breakfastTitle: "Frukost",
      breakfastText:
        "Klockan 10 efterföljande morgon bjuder brudgummens föräldrar på frukost i Ytternuttö 123.",

      accommodationTitle: "Boende",
      accommodationText: (
        <>
          <p>
            Vill ni övernatta i närheten rekommenderar vi att boka boende i
            Östhammar eller Öregrund i god tid. Vi har reserverat rum för er att boka på:
          
            <ul> 
              <li>Gårdshotell Klockargården, ange koden ADAMFREDRIKA i bokningen på klockargarden.nu</li> 
              <li>Hotell Flora, maila info@hotellflora.se och ange ADAMFREDRIKA</li> 
              <li>Klackskärs camping (stugor), maila info@klackskarscamping.com och ange ADAMFREDRIKA</li> 
            </ul> Det finns naturligtvis även andra hotell och airbnb's att boka.
          </p>
     
        </>
      ),

      transportTitle: "Transport",
      transportText: (
        <>
          <p>
            Man kan ta sig till och från bröllopet med kollektivtrafik (UL, buss 811) från Uppsala, Öregrund och Östhammar: 
            <ul style={{ textAlign: "left", maxWidth: "3000px", margin: "10px" }}> 
              <li>Kyrkans närmsta hållplats heter Hökhuvuds kyrka.</li> 
              <li>Bygdegårdens närmsta hållplats heter Uppskedika.</li> 
            </ul> 
            <p>
            En gemensam buss tar gäster från kyrkan till bygdegården.
            </p>
            När festen slutar vid 02.30 kommer det även att gå en privat nattbuss från bygdegården till Östhammar och Öregrund.
          </p>
        </>
      ),

      closing: "Vi ses snart!",
    },

    en: {
      date: "15 August 2026",
      location: "Hökhuvuds Kyrka, Östhammar",
      party: "Reception to follow at Hökhuvuds Bygdegård",
      rsvpText: "Please let us know if you can attend by June 1st.",
      rsvpButton: "RSVP here",
      moreInfo: "More information about the day",

      ceremonyTitle: "Ceremony",
      ceremonyText:
        "The ceremony will take place at Hökhuvud Church, Gimo, at 2:00 PM.",

      celebrationTitle: "Celebration – dinner and party",
      celebrationText:
        "Shared transportation will be provided from the church to Hökhuvuds Community Hall for mingling, dinner, and celebration.",

      dressTitle: "Dress code",
      dressText: "Summer formal attire.",

      childrenTitle: "Children",
      childrenText:
        "We love children, but this day will be celebrated in adult company.",

      speechTitle: "Speeches and questions",
      speechText:
        "Please contact our toastmasters if you wish to give a speech or have any questions: adamfredrikatoast@gmail.com",

      giftsTitle: "Gifts",
      giftsText:
        "Your presence is the greatest gift. If you wish to give something, a contribution to our honeymoon would be appreciated. Swish and coordination is handled by toastmaster Johanna Dyremark, +46704891716",

      breakfastTitle: "Breakfast",
      breakfastText:
        "At 10:00 AM the following morning, breakfast will be hosted by the groom's parents in Ytternuttö 123.",

      accommodationTitle: "Accommodation",
      accommodationText: (
        <>
          <p>
            If you wish to stay overnight nearby, we recommend booking
            accommodation in Östhammar or Öregrund well in advance. We have reserved rooms to book at:
              <ul> 
                <li>Gårdshotell Klockargården – use the code ADAMFREDRIKA when booking at klockargarden.nu</li> 
                <li>Hotell Flora – email info@hotellflora.se and mention ADAMFREDRIKA</li> 
                <li>Klackskärs camping (cabins) – email info@klackskarscamping.com and mention ADAMFREDRIKA</li> 
              </ul>
              There are of course also other hotels and Airbnbs available to book.
          </p>
          <p>
            
          </p>
        </>
      ),

      transportTitle: "Transportation",
      transportText: (
        <>
          <p>
            You can travel to and from the wedding using public transportation (UL, bus 811) from Uppsala, Öregrund, and Östhammar:
            <ul style={{ textAlign: "left", maxWidth: "3000px", margin: "10px" }}> 
              <li>The closest stop to the church is called Hökhuvuds kyrka.</li> 
              <li>The closest stop to the community hall is called Uppskedika.</li> 
            </ul>
          </p>
          <p>
            A shared bus will take guests from the church to the reception.
          </p>
          <p>
            When the celebration ends at 2:30 AM, a private night bus will depart from the bygdegård, with stops in Östhammar and Öregrund.
          </p>
        </>
      ),

      closing: "See you soon!",
    },
  };

  const t = text[lang];

  return (
    <div
      style={{
        backgroundColor: "rgb(255, 242, 204)",
        minHeight: "100vh",
        padding: "16px", // slightly bigger for mobile
        display: "flex",
        justifyContent: "center",
      }}
    >
    
      <div
        style={{
          maxWidth: "1050px",
          fontFamily: "Georgia, serif",
          textAlign: "center",
        }}
      >
        {/* LANGUAGE SWITCH */}
        <div style={{ textAlign: "right", marginBottom: "20px" }}>
          <button
            onClick={() => setLang("sv")}
            style={{
              background: "none",
              fontFamily: "Georgia, serif",
              border: "none",
              cursor: "pointer",
              color: lang === "sv" ? "#000" : "#777",
              textDecoration: lang === "sv" ? "underline" : "none",
              marginRight: "8px",
            }}
          >
            SV
          </button>
          |
          <button
            onClick={() => setLang("en")}
            style={{
              background: "none",
              border: "none",
              fontFamily: "Georgia, serif",
              cursor: "pointer",
              color: lang === "en" ? "#000" : "#777",
              textDecoration: lang === "en" ? "underline" : "none",
              marginLeft: "8px",
            }}
          >
            EN
          </button>
        </div>

        {/* STAMP */}
        <div style={{ maxWidth: "250px", width: "100%", margin: "0 auto" }}>
          <img src="/stamp_flower.png" alt="Stämpel" width="100%" />
        </div>

        <h2>Fredrika & Adam</h2>
        <p>{t.date}</p>
        <p>{t.location}</p>
        <p>{t.party}</p>

        <p style={{ marginTop: "40px" }}>{t.rsvpText}</p>

        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSd5qu4fA2nMMKYOU6yNl_hDKUcc0M5Nh89274d4hwEKdoiA6g/viewform"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            padding: "10px 54px",
            border: "2px solid #9cad6b",
            textDecoration: "none",
            color: "#333",
            marginBottom: "30px",
          }}
        >
          {t.rsvpButton}
        </a>

        {/* PHOTO */}
        <div style={{ maxWidth: "520px", width: "100%", margin: "0 auto" }}>
          <img src="/IMG_2243.JPG" alt="Fredrika och Adam" width="100%" />
        </div>
        

        {/* INFO (NARROWER SECTION) */}
        <div style={{ 
          maxWidth: "520px", 
          margin: "30px auto", 
          lineHeight: "1.6",
          textAlign: "left",
          wordBreak: "break-word", 
          }}>
          <h3 style={{ textAlign: "center" }}>{t.moreInfo}</h3>

          <p style={{ fontWeight: "bold" }}>{t.ceremonyTitle}</p>
          <p>{t.ceremonyText}</p>

          <p style={{ fontWeight: "bold" }}>{t.celebrationTitle}</p>
          <p>{t.celebrationText}</p>

          <p style={{ fontWeight: "bold" }}>{t.dressTitle}</p>
          <p>{t.dressText}</p>

          <p style={{ fontWeight: "bold" }}>{t.childrenTitle}</p>
          <p>{t.childrenText}</p>

          <p style={{ fontWeight: "bold" }}>{t.speechTitle}</p>
          <p>{t.speechText}</p>

          <p style={{ fontWeight: "bold" }}>{t.giftsTitle}</p>
          <p>{t.giftsText}</p>

          <p style={{ fontWeight: "bold" }}>{t.breakfastTitle}</p>
          <p>{t.breakfastText}</p>

          <p style={{ fontWeight: "bold" }}>{t.accommodationTitle}</p>
          {t.accommodationText}

          <p style={{ fontWeight: "bold" }}>{t.transportTitle}</p>
          {t.transportText}
        </div>

        <br/>
        <br/>
        <p>{t.closing}</p>
        <p>Fredrika & Adam</p>
      </div>
    </div>
  );
}
